module.exports = __webpack_public_path__ + "static/media/send_ee.9d83a757.svg";